module.exports = __webpack_public_path__ + "static/property-app-2-bd2ac4b8f5bab7451bf1159cea24313c.png";